import { render, staticRenderFns } from "./PrestonMosquesForAlAqsa.vue?vue&type=template&id=d040a696&scoped=true"
import script from "./PrestonMosquesForAlAqsa.vue?vue&type=script&lang=js"
export * from "./PrestonMosquesForAlAqsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d040a696",
  null
  
)

export default component.exports